<template>
  <path
    d="M11 7.00018H13V9.00018H11V7.00018ZM12 17.0002C12.55 17.0002 13 16.5502 13 16.0002V12.0002C13 11.4502 12.55 11.0002 12 11.0002C11.45 11.0002 11 11.4502 11 12.0002V16.0002C11 16.5502 11.45 17.0002 12 17.0002ZM12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM12 20.0002C7.59 20.0002 4 16.4102 4 12.0002C4 7.59018 7.59 4.00018 12 4.00018C16.41 4.00018 20 7.59018 20 12.0002C20 16.4102 16.41 20.0002 12 20.0002Z"
  />
</template>
